import { loadScript } from "../../../utils/js/utils.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";

export function init() {
  // TODO: feature flag?
  loadTmt();
}

function loadTmt() {
  const dispatch = () => {
    // maybe somebody cares?
    events.fire(window, "the.media.trust.loaded");
  };

  loadScript(
    "https://scripts.webcontentassessor.com/scripts/3c9d6a4bddfdc72841ad7b6d716004544cad77fd335d439f7f7ec71101bc0470"
  ).then(dispatch);
}
